export default __webpack_public_path__ + "media/images/annuler-icone-9382-16-f6fc6b2f361f74a2c13d4a6d3ec129ca.png";